import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Globals } from '../../ressources/variables/globals';
import { AcrcloudFingerprint } from '../../ressources/types/acrcloudFingerprint';

@Injectable()
export class AnalyzerService {

  serverEndpoint = Globals.serverEndpoint;

  constructor(private http: HttpClient) { }

  acrcloudAnalyzeFingerprint(folder, filename, position): Promise<AcrcloudFingerprint> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new HttpParams()
      .set('filename', filename)
      .set('folder', folder)
      .set('position', position);
    return this.http.post<AcrcloudFingerprint>(this.serverEndpoint + '/api/acrcloudAnalyzeFingerprint',
      body.toString().replace(/\+/gi, '%2B'), { headers }).toPromise();
  }

  fileMetadata(folder, filename, position): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new HttpParams()
      .set('folder', folder)
      .set('filename', filename)
      .set('position', position);
    return this.http.post(this.serverEndpoint + '/api/fileMetadata',
      body.toString().replace(/\+/gi, '%2B'), { headers }).toPromise();
  }
}
